import { createRouter, createWebHistory, RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import { vuexStore } from '@/stores/vuex/index'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import { useRouteStore } from '@/stores/routeStore'

import { globalRoutes } from './globalRoutes'

const routes: RouteRecordRaw[] = [...globalRoutes]

const router = createRouter({
  history: createWebHistory(),
  routes,
})
router.beforeEach(vuexOidcCreateRouterMiddleware(vuexStore))
//router.beforeEach(preload)
router.beforeEach(async (to) => {
  updateRouteParamsInStore(to)
})

function updateRouteParamsInStore(to: RouteLocationNormalized): void {
  const routeStore = useRouteStore()

  routeStore.setFullPath(to.fullPath)

  if (
    to.params.projectId !== undefined &&
    to.params.projectId !== 'undefined' &&
    typeof to.params.projectId === 'string'
  ) {
    routeStore.setProjectId(to.params.projectId)
  } else {
    routeStore.setProjectId(undefined)
  }

  if (
    to.params.snapshotId !== undefined &&
    to.params.snapshotId !== 'undefined' &&
    typeof to.params.snapshotId === 'string'
  ) {
    routeStore.setSnapshotId(to.params.snapshotId)
  } else {
    routeStore.setSnapshotId(undefined)
  }

  if (
    to.params.artifactId !== undefined &&
    to.params.artifactId !== 'undefined' &&
    to.params.artifactId !== ':artifactId' &&
    typeof to.params.artifactId === 'string'
  ) {
    routeStore.setArtifactId(to.params.artifactId)
  } else {
    routeStore.setArtifactId(undefined)
  }

  if (
    to.params.metricsDetailsPath !== undefined &&
    to.params.metricsDetailsPath !== 'undefined' &&
    typeof to.params.metricsDetailsPath === 'string' &&
    to.params.seriesName !== undefined &&
    to.params.seriesName !== 'undefined' &&
    typeof to.params.seriesName === 'string'
  ) {
    routeStore.setChartDetailsPath(to.params.metricsDetailsPath + '/' + to.params.seriesName)
  } else {
    routeStore.setChartDetailsPath(undefined)
  }

  if (
    to.query.filter !== undefined &&
    to.query.filter !== 'undefined' &&
    typeof to.query.filter === 'string'
  ) {
    routeStore.setFilterId(to.query.filter)
  } else {
    routeStore.setFilterId(undefined)
  }
}

export default router
